import getYear from '@teetsh/app/src/utils/time/getYear';

const yearsAvailable = [-1, 0, 1, 2, 3, 4, 5, 6, 7].map((n: number) => ({
  label: `${getYear(new Date()) - n} - ${getYear(new Date()) - (n - 1)}`,
  // eslint-disable-next-line no-mixed-operators
  value: getYear(new Date()) + 1 - n,
}));

const closeYearsAvailable = [1, 0, -1].map((n: number) => ({
  // eslint-disable-next-line no-mixed-operators
  value: getYear(new Date()) + 1 - n,
}));

export { yearsAvailable, closeYearsAvailable };
